import { AppState } from "../types";

export const wizardNoPersistSelectors = {
  mode(state: AppState) {
    return state.wizardNoPersist.mode;
  },
};
